// ===================================
// KAIXO CRM - API Service (aislado)
// ===================================

import api from './api';

const CRM = '/crm';

function uid() {
    try { return JSON.parse(localStorage.getItem('kaixo_user') || '{}')._id || ''; }
    catch { return ''; }
}

// Normaliza ids que pueden llegar como objeto de Mongo/populate.
function id(v) {
    if (!v) return '';
    if (typeof v === 'string') return v === '[object Object]' ? '' : v;
    if (typeof v === 'object') {
        if (typeof v.toHexString === 'function') {
            try { return v.toHexString(); } catch { /* noop */ }
        }
        return String(v._id || v.id || '');
    }
    return String(v);
}

// Acceso
export const crmCheckAccess = () => api.get(`${CRM}/access`, { params: { userId: uid() } });
export const crmActivate = () => api.post(`${CRM}/activate`, { userId: uid() });

// Dashboard
export const crmGetDashboard = () => api.get(`${CRM}/dashboard`, { params: { userId: uid() } });

// Leads
export const crmGetLeads = (params) => api.get(`${CRM}/leads`, { params: { ...params, userId: uid() } });
export const crmCreateLead = (data) => api.post(`${CRM}/leads`, { ...data, userId: uid() });
export const crmUpdateLead = (leadId, data) => api.put(`${CRM}/leads/${id(leadId)}`, { ...data, userId: uid() });
export const crmDeleteLead = (leadId) => api.delete(`${CRM}/leads/${id(leadId)}`, { params: { userId: uid() } });
export const crmAddAppointment = (leadId, data) => api.post(`${CRM}/leads/${id(leadId)}/appointments`, { ...data, userId: uid() });

// Agenda — próxima acción / pendientes / atrasadas
export const crmGetAgenda = () => api.get(`${CRM}/agenda`, { params: { userId: uid() } });
export const crmSetNextAction = (leadId, data) => api.put(`${CRM}/leads/${id(leadId)}/action`, { ...data, userId: uid() });
export const crmCompleteAction = (leadId) => api.post(`${CRM}/leads/${id(leadId)}/action/complete`, { userId: uid() });

// Notas — historial de interacciones agente↔lead
export const crmGetNotes = (params) => api.get(`${CRM}/notes`, { params: { ...params, userId: uid() } });
export const crmGetLeadNotes = (leadId) => api.get(`${CRM}/leads/${id(leadId)}/notes`, { params: { userId: uid() } });
export const crmCreateNote = (leadId, data) => api.post(`${CRM}/leads/${id(leadId)}/notes`, { ...data, userId: uid() });
export const crmDeleteNote = (noteId) => api.delete(`${CRM}/notes/${id(noteId)}`, { params: { userId: uid() } });

// Pipeline
export const crmGetPipeline = () => api.get(`${CRM}/pipeline`, { params: { userId: uid() } });
export const crmUpdatePipeline = (data) => api.put(`${CRM}/pipeline`, { ...data, userId: uid() });

// Agents
export const crmGetAgents = () => api.get(`${CRM}/agents`, { params: { userId: uid() } });
export const crmGetAgentDetail = (agentId) => api.get(`${CRM}/agents/${id(agentId)}`, { params: { userId: uid() } });
export const crmUpdateAgent = (agentId, data) => api.put(`${CRM}/agents/${id(agentId)}`, { ...data, userId: uid() });
export const crmAddAgent = (data) => api.post(`${CRM}/agents`, { ...data, userId: uid() });
export const crmRemoveAgent = (agentId) => api.delete(`${CRM}/agents/${id(agentId)}`, { params: { userId: uid() } });

// Activity
export const crmGetActivity = (params) => api.get(`${CRM}/activity`, { params: { ...params, userId: uid() } });
export const crmGetBestAds = () => api.get(`${CRM}/best-ads`, { params: { userId: uid() } });
export const crmAssignUnassigned = () => api.post(`${CRM}/assign-unassigned`, { userId: uid() });

// Reports
export const crmGetReports = (params) => api.get(`${CRM}/reports`, { params: { ...params, userId: uid() } });

// Conversion Insights — qué está aprendiendo el algoritmo del feed
// de las conversiones cerradas en tu CRM. Muestra top países/idiomas/
// intereses de los compradores que SÍ convierten.
export const crmGetConversionInsights = () => api.get(`${CRM}/conversion-insights`, { params: { userId: uid() } });
